export interface RouteDefinition {
    id: string
    predicates: PredicateDefinition[]
    filters: PredicateDefinition[]
    uri: string
    metadata: object
    order: number
    address: string[]
    enabled: boolean
    authDefine: AuthDefine
    loggingDefine?: LoggingDefine
    secretDefine?: SecretDefine[]
}

export interface PredicateDefinition {
    name: string
    args: any
}

export interface AuthDefine {
    enable: boolean
    skipPath: string[]
}

export interface LoggingDefine {
    enable: boolean,
    level: LoggingLevel
    extensions?: any
}

export interface SecretDefine {
    path: string,
    filters: string[]
}

export enum LoggingLevel {
    DEBUG = 'DEBUG',
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR'
}
